import { ValidatedNumberInput, ValidatedTextInput } from "../../../../common/inputs/ValidatedInputs";
import EntityEditor from "../../../../common/Tables/EntityEditor";
import { Box } from "@mui/material";
import { useRoomsData } from "../../../../common/hooks/useRoomsData";

const roomEditorStyle = ({ theme }) => ({
    '& .MuiPaper-root': {
        width: '80%',
        maxWidth: '500px'
    }
});

const emptyRoom = {
    name: '',
    description: '',
    count: 1,
    maxOccupancy: 1
};

const RoomEditor = ({ propertyId, onSuccess, onClose, editedRoom, existingRooms, onError }) => {
    const { createRoom, updateRoom } = useRoomsData(propertyId);

    const defaultRoom = editedRoom || emptyRoom;
    const isEditing = !!editedRoom;

    const submitAction = isEditing ? updateRoom : createRoom;

    const title = isEditing ? `Editing room: ${editedRoom.name}` : "Creating a new room";

    const EditorContent = (props) => {
        const { entity, onChange, disabled, entityChanged } = props;
        const room = entity;

        return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <ValidatedTextInput
                size='small'
                autoFocus
                margin="dense"
                id="name"
                label="Name"
                type="text"
                fullWidth
                required
                unique={{ existingValues: existingRooms.map(room => room.name).filter(name => !isEditing ? true : name !== editedRoom.name) }}
                onChange={onChange}
                disabled={disabled}
                value={room.name}
                disableError={!entityChanged}
            />
            <ValidatedTextInput
                size='small'
                margin="dense"
                id="description"
                label="Description"
                type="text"
                fullWidth
                multiline
                rows="2"
                onChange={onChange}
                disabled={disabled}
                value={room.description}
            />
            <ValidatedNumberInput
                key={'count'}
                size='small'
                margin="dense"
                id="count"
                label="Quantity"
                min={1}
                max={20}
                required
                onChange={onChange}
                disabled={disabled}
                value={room.count}
                decimals={0}
                sx={{
                    width: 100
                }}
            />
            <ValidatedNumberInput
                key={'maxOccupancy'}
                size='small'
                margin="dense"
                id="maxOccupancy"
                label="Max occupancy"
                min={1}
                max={10}
                required
                onChange={onChange}
                disabled={disabled}
                decimals={0}
                value={room.maxOccupancy}
                sx={{
                    width: 100
                }}
            />
        </Box>
    };

    return <EntityEditor
        dialogProps={{ sx: roomEditorStyle }}
        title={title}
        defaultEntity={defaultRoom}
        entityName='Room'
        submitAction={submitAction}
        editing={isEditing}
        onClose={onClose}
        onSuccess={onSuccess}
        EditorContent={EditorContent}
        onError={onError}
    />
}

export default RoomEditor;